import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

export default function WhatsAppFab() {
  const { pathname } = useLocation();
  // Nella landing funnel /checkup (traffico Meta Ads) nessuna via di uscita
  if (pathname.startsWith("/checkup")) return null;
  const phone = "393475061407";
  const msg = encodeURIComponent("Ciao Roberta, vorrei maggiori informazioni sui tuoi servizi.");
  return (
    <a
      data-testid="whatsapp-fab"
      href={`https://wa.me/${phone}?text=${msg}`}
      target="_blank" rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#323C36] hover:bg-[#1F2822] text-[#F6F3EF] w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-transform hover:-translate-y-0.5"
      aria-label="Contatta su WhatsApp"
    >
      <MessageCircle size={22} />
    </a>
  );
}
